import { Component } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <a class="matero-branding" href="/">
      <img src="./assets/images/PASM-logo.svg" class="matero-branding-logo-expanded" alt="logo" />
      <span class="matero-branding-name">Power & Air Solutions</span>
    </a>
  `,
})
export class BrandingComponent {}
